export default __webpack_public_path__ + "static/media/iconSairCompartilhamento.8dc7b390.svg";